import React, { createContext, useContext } from "react";
import { convertNumberToPrice, parseForMarkdownBold, parseForMarkdownLinks } from "../../helpers";

import "./style.scss";

const PriceContext = createContext(null);

function usePriceContext() {
  const context = useContext(PriceContext);
  if (!context) {
    throw new Error("Subcomponents of Price must be used within the Price component!");
  }
  return context;
}

function Price({children}) {
  return (
    <PriceContext.Provider value={{}}>
      <div className="Price">
        {children}
      </div>
    </PriceContext.Provider>
  );
}

function PriceHeader({content}) {
  const { title, image, infobox, colors } = content;
  usePriceContext();
  return (
    <div className="PriceHeader">
      <img className="PriceHeader__image" src={image.sizes.medium} alt={image.alt} />
      <div className="PriceHeader__infobox">
        <h2 className="PriceHeader__title">{title}</h2>
        <div
          style={{
            backgroundColor: colors.background_color,
          }}
          className="PriceHeader__text"
          dangerouslySetInnerHTML={{ __html: parseForMarkdownLinks(parseForMarkdownBold(infobox), colors.link_color) }}
        />
      </div>
    </div>
  );  
}

function PriceList({children}) {
  usePriceContext();
  return (
    <ul className="PriceList">{children}</ul>
  );  
}

function PriceItem({content}) {
  usePriceContext();
  const { field, details } = content;
  const { image, double_span } = field;
  const { title, description, price, additional } = details;
  return (
    <li className={`PriceItem${double_span ? " PriceItem--doublespan" : ""}`}>
      <img className="PriceItem__image" src={image.sizes.medium} alt={image.alt} />
      <div className="PriceItem__details">
        <h3 className="PriceItem__title">{title}</h3>
        {description && <p className="PriceItem__description">{description}</p>}
        <p className="PriceItem__price">{convertNumberToPrice(price)}</p>
        {additional && <p className="PriceItem__additional">{additional}</p>}
      </div>
    </li>
  );  
}

Price.Header = PriceHeader;
Price.List = PriceList;
Price.Item = PriceItem;

export default Price;
